module.exports = __webpack_public_path__ + "static/media/shandy4u.6946a847.png";